import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 43296 26721"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#040404}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M13448 10620h6373c177 660 93 10782 67 12395-1049 521-1685 3049-1041 3214 116 30 136 26 256 29l4698-8c682 0 653 90 639-633-16-794-89-1655-716-2195-256-220-50-120-542-493-96-3399-15-7755-12-11186 1-1231-163-1164 701-1164l5452 2c982 0 1779 53 2296-1025 111-231 227-568 244-852 17-301-72-710-147-958l-535-815c-519-330-867-367-1582-367l-16012 1c-753 0-1230 53-1621 450-128 129-386 424-453 581-38 90-210 809-217 904-42 523 216 1183 605 1550 539 508 592 569 1547 570z"
        className="fil0"
      />
      <path
        d="M4174 26078c89 399 742 858 1227 530 27-18 187-168 211-199 39-53 110-202 132-281 335-1202-365-9297 212-9453 316-84 4118-35 4455-35 536 0 4551-164 4581 114 13 116 73-53 65 648-15 1269-73 8211 70 8476 169 314 756 536 1136 277 405-277 328-727 328-1299 0-3083 0-6166 1-9248 0-594-203-1362-530-1785-536-692-582-758-1262-1014-809-302-3666-168-4596-169-2480-1-1142 32-1654-1800-710-2548-595-3689-2384-6163-8-12-21-28-29-40-26-37-78-117-108-165-84-126-167-253-252-379-203-271-348-434-517-655-284-373-1414-1503-1817-1774-110-74-230-146-326-229-645-558-865-695-1635-1062C746 22-123-26 15 981c37 274 331 650 554 1067 149 241 298 482 447 724 154 301 230 461 383 801 937 2199 2469 5767 2510 8243 76 4691 251 9471 265 14262z"
        style={{
          fill: "#050505",
        }}
        className="fill"
      />
      <path
        d="m34469 12674-4939 7c-685 0-862 31-1349 257-484 226-972 676-1208 1160-115 236-168 290-298 515-211 367-108 1163-110 1685l1 8558c0 435-113 1446 825 1412 903-33 746-650 746-1550l16-8058c2941-78 6177-18 9177-20 164 1026 71 7471 73 9045 2 587 224 1066 887 985 115-14 306-90 376-131 242-143 81 59 220-263 134-311 99-486 99-868l1-11802c1-517 237-2990 350-3327l1414-4433c72-160 64-126 118-226 103-189 438-1239 750-1668l426-805c266-632 343-682 651-1227 437-776 847-925 421-1624-368-601-1094-118-1304-15-263 131-478 277-736 437-1333 829-1385 1041-1801 1316l-1781 1942c-456 638-640 785-949 1484l-451 782c-181 370-18 58-236 364l-209 411c-353 937-862 2507-904 3483-18 430-124 1893-276 2174z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
